/**
 * tm/components/CompanySmsLog.tsx — 업체 「커뮤니케이션」 탭의 「보낸 문자」 (2026-10-28 지도사 「전산에서 알리고로 문자 나간 거 있으면 고객이든 팀장님이든 어디에 표시해 줘 · 뭐라고 나갔는지 알아야지」)
 *  최근 것부터 한 줄씩: 날짜 시각 · 받는 사람(대표님 · ○○ 팀장님 · WM · 번호) · 무슨 문자(상담 결과 · 동행상담 전날 확인 …) · 못 보냄이면 빨강
 *  줄을 누르면 보낸 글 전체 · 처음엔 5개 · 「더 보기」 · 서버 GET /api/tm/companies/:id/sms-log(services/smsLog)
 */
import { useEffect, useState } from 'react';
import { C, T } from './ui';
import { req } from '../api';
import { SmsStateTag, asSmsState } from '../smsState';

interface Sms { id: string; at: string; to: string; who: string; role: string; message: string; status: string; error: string; kind: string; type: string; state?: string; note?: string }

const when = (iso: string) => {
  const d = new Date(new Date(iso).getTime() + 9 * 3600 * 1000);
  if (isNaN(d.getTime())) return '';
  const h = d.getUTCHours(), mi = String(d.getUTCMinutes()).padStart(2, '0');
  return `${d.getUTCMonth() + 1}/${d.getUTCDate()} ${h < 12 ? '오전' : '오후'} ${h % 12 || 12}:${mi}`;
};
const phoneOf = (p: string) => { const d = String(p || '').replace(/\D/g, ''); return d.length === 11 ? `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}` : p; };

export default function CompanySmsLog({ companyId }: { companyId: string }) {
  const [list, setList] = useState<Sms[] | null>(null);
  const [open, setOpen] = useState('');
  const [all, setAll] = useState(false);
  useEffect(() => {
    let alive = true;
    setList(null);
    req<Sms[]>('GET', `/companies/${companyId}/sms-log`).then(r => { if (alive) setList(r.data || []); }).catch(() => { if (alive) setList([]); });
    return () => { alive = false; };
  }, [companyId]);
  if (!list) return null;
  const shown = all ? list : list.slice(0, 5);
  return (
    <div style={{ marginTop: 28 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8 }}>
        <span style={{ fontSize: T.md, fontWeight: 700, color: C.text }}>보낸 문자</span>
        <span style={{ fontSize: T.xs, color: C.muted }}>{list.length ? `${list.length}건 · 전산에서 나간 문자(대표님 · 팀장님 · WM)` : '아직 이 업체로 나간 문자가 없어요'}</span>
      </div>
      {list.length > 0 && (
        <div style={{ border: `1px solid ${C.border}`, borderRadius: 10, background: '#fff', overflow: 'hidden' }}>
          {shown.map((s, i) => {
            const bad = s.status === 'failed';
            const isOpen = open === s.id;
            return (
              <div key={s.id} style={{ borderTop: i ? `1px solid ${C.border}` : 'none' }}>
                <button type="button" aria-expanded={isOpen} onClick={() => setOpen(isOpen ? '' : s.id)}
                  style={{ width: '100%', display: 'grid', gridTemplateColumns: '108px 150px minmax(0,1fr) auto', gap: 10, alignItems: 'center', padding: '9px 12px', border: 'none', background: isOpen ? '#F8FAFC' : '#fff', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', fontSize: T.sm }}>
                  <span style={{ color: C.sub, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{when(s.at)}</span>
                  <span style={{ fontWeight: 700, color: C.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.who || phoneOf(s.to)}</span>
                  <span style={{ color: C.sub, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.kind ? <b style={{ color: C.text, fontWeight: 600 }}>{s.kind} · </b> : null}{s.message.replace(/\s+/g, ' ')}</span>
                  <SmsStateTag state={s.state ? asSmsState(s.state) : bad ? 'rejected' : 'wait'} note={s.note || s.error} />
                </button>
                {isOpen && (
                  <div style={{ padding: '4px 12px 12px 130px', background: '#F8FAFC' }}>
                    <div style={{ fontSize: T.xs, color: C.muted, marginBottom: 6 }}>{[phoneOf(s.to), s.type, bad && s.error ? `이유: ${s.error}` : '', s.state === 'fail' && s.note ? `통신사: ${s.note}` : ''].filter(Boolean).join(' · ')}</div>
                    <div style={{ fontSize: T.sm, color: C.text, lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-all', background: '#fff', border: `1px solid ${C.border}`, borderRadius: 8, padding: '10px 12px', userSelect: 'text' }}>{s.message}</div>
                  </div>
                )}
              </div>
            );
          })}
          {list.length > 5 && <button type="button" onClick={() => setAll(v => !v)} style={{ width: '100%', padding: '8px 0', border: 'none', borderTop: `1px solid ${C.border}`, background: '#fff', color: C.accent, fontSize: T.sm, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>{all ? '접기' : `더 보기 (${list.length - 5}건)`}</button>}
        </div>
      )}
    </div>
  );
}
